export default "__VITE_ASSET__e1f338ba__"